const section = document.querySelector('.global-section-room');

if (section) {
    const wrapper = section.querySelector('.global-section-room__carousel-wrapper');
    const track   = section.querySelector('.global-section-room__carousel');
    const dots    = [...section.querySelectorAll('.global-section-room__dot')];
    const prevBtn = section.querySelector('.global-section-room__prev');
    const nextBtn = section.querySelector('.global-section-room__next');

    const originalCards = [...section.querySelectorAll('.global-section-room__card')];
    const total = originalCards.length;

    if (total > 0) {
        const clonesStart = originalCards.map(c => c.cloneNode(true));
        const clonesEnd   = originalCards.map(c => c.cloneNode(true));

        clonesEnd.forEach(c => track.appendChild(c));
        track.prepend(...clonesStart);

        // Layout: [A', B', C', A, B, C, A'', B'', C'']
        // Real cards start at index `total`
        let currentIndex = total;
        let isAnimating  = false;

        function getCardWidth() {
            return track.children[0]?.offsetWidth || 0;
        }

        function getGap() {
            return parseFloat(getComputedStyle(track).gap) || 0;
        }

        function getTranslateX(index) {
            const cardWidth     = getCardWidth();
            const gap           = getGap();
            const viewportWidth = document.documentElement.clientWidth;
            const visibleCards  = viewportWidth < 768 ? 1 : 2;
            const totalWidth    = visibleCards * cardWidth + (visibleCards - 1) * gap;
            const centerOffset  = (viewportWidth - totalWidth) / 2;
            return centerOffset - index * (cardWidth + gap);
        }

        function setPosition(index, animated) {
            if (!animated) {
                track.style.transition = 'none';
                track.style.transform = `translateX(${getTranslateX(index)}px)`;
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    track.style.transition = '';
                }));
            } else {
                track.style.transform = `translateX(${getTranslateX(index)}px)`;
            }
        }

        function updateDots(index) {
            const realIndex = ((index - total) % total + total) % total;
            dots.forEach((dot, i) => {
                dot.classList.toggle('global-section-room__dot--active', i === realIndex);
            });
        }

        function goTo(index) {
            if (isAnimating) return;
            isAnimating  = true;
            currentIndex = index;
            setPosition(currentIndex, true);
            updateDots(currentIndex);
        }

        track.addEventListener('transitionend', (e) => {
            if (e.target !== track) return;
            isAnimating = false;

            if (currentIndex < total) {
                currentIndex += total;
                setPosition(currentIndex, false);
            } else if (currentIndex >= total * 2) {
                currentIndex -= total;
                setPosition(currentIndex, false);
            }
        });

        setPosition(currentIndex, false);
        updateDots(currentIndex);

        prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
        nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

        // Touch swipe
        let touchStartX = 0;

        track.addEventListener('touchstart', e => {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });

        track.addEventListener('touchend', e => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
            }
        }, { passive: true });

        // Mouse drag
        let mouseStartX  = 0;
        let isDragging   = false;

        track.addEventListener('mousedown', e => {
            mouseStartX = e.clientX;
            isDragging  = true;
            track.style.cursor = 'grabbing';
        });

        window.addEventListener('mousemove', e => {
            if (!isDragging) return;
            e.preventDefault();
        });

        window.addEventListener('mouseup', e => {
            if (!isDragging) return;
            isDragging = false;
            track.style.cursor = '';
            const diff = mouseStartX - e.clientX;
            if (Math.abs(diff) > 50) {
                goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
            }
        });

        window.addEventListener('resize', () => {
            isAnimating = false; // une transition coupée par le resize ne déclenche jamais transitionend
            setPosition(currentIndex, false);
        });
    }
}
